export const LANGUAGE_MODAL_KEY = 'language';
export const APPGAME_CHANGEPW_MODAL_KEY = 'appGameChangePW';
